import { ReactNode } from "react";

export default function Layout({ children }: { children: ReactNode }) {
  return (
    <main className="custom-container flex h-dvh flex-col overflow-y-auto pb-14 pt-8">
      {children}
    </main>
  );
}
